import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {environment} from '@app/environments/environment';
import {HttpClient} from '@angular/common/http';
import {AWSService} from '@app/app/shared/services/aws.service';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'update-controller-dialog',
  templateUrl: 'update.controller.dialog.html',
})

export class UpdateControllerDialogComponent implements OnInit, OnDestroy {
  updateControllerForm: FormGroup;
  file: any;
  isUploadingFile = false;
  controllerId = null;
  parkId = null;
  saveInProgress = false;
  messagesSubscription: Subscription;
  timerSub: Subscription;
  mqttConnection: any;
  currentTopic: string;
  public progressMessages = ['Update in progress. This may take a few minutes...'];

  private updateType = null;

  constructor(public dialogRef: MatDialogRef<UpdateControllerDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private http: HttpClient,
              private aws: AWSService) {
    this.controllerId = data.controllerId;
    this.parkId = data.parkId;

    this.updateControllerForm = new FormGroup({
      url: new FormControl('', Validators.required),
    });
  }

  private completeUpdate(topic, result) {
    if (this.currentTopic === topic && this.mqttConnection) {
      this.mqttConnection.unsubscribe(topic);
    }

    // update completed successfully
    this.saveInProgress = false;
    this.dialogRef.disableClose = false;

    this.dialogRef.close({success: true, message: result});
  }

  ngOnInit() {
    this.messagesSubscription = this.aws.messagesObservable.subscribe((message: { topic: string, message: any }) => {
      if (message.message.hasOwnProperty('jsonrpc')) {
        if (message.message.hasOwnProperty('method')) {
          // we received our command, just ignore it
        } else if (message.message.hasOwnProperty('result')) {
           if (this.updateType === 'firmwaretest') {
             const result = message.message.result;

             if (result === 'Will now reboot') {
               this.completeUpdate(message.topic, 'Controller updated and will be rebooted');
             }

             this.progressMessages.push(message.message.result);
           } else {
             this.completeUpdate(message.topic, message.message.result);
           }
        } else if (message.message.hasOwnProperty('error')) {
          if (this.currentTopic === message.topic && this.mqttConnection) {
            this.mqttConnection.unsubscribe(message.topic);
          }

          // update completed with error
          this.saveInProgress = false;
          this.dialogRef.disableClose = false;

          if (message.message.error.hasOwnProperty('data')) {
            alert(message.message.error.data);
          } else {
            alert('Unknown error');
          }
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.messagesSubscription) {
      this.messagesSubscription.unsubscribe();
    }

    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  onSubmit({value, valid}) {
    this.updateType = null;

    if (valid) {
      this.saveInProgress = true;
      this.dialogRef.disableClose = true;

      const commandId: string = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

      const data = {
        jsonrpc: environment.jsonrpcVersion,
        method: 'update',
        params: {url: value.url},
        id: commandId
      };

      this.updateType = value.type;

      this.currentTopic = `${this.parkId}/updates/${commandId}`;

      this.aws.connect2().subscribe(conn => {
        this.mqttConnection = conn;

        this.mqttConnection.subscribe(
          this.currentTopic,
          {qos: 1},
          (err, granted) => {
            this.mqttConnection.publish(this.currentTopic, JSON.stringify(data), {qos: 1});

            this.timerSub = Observable.of(true).delay(this.getDelay(value.type)).subscribe(() => {
              if (this.saveInProgress) {
                alert('Timed Out');
              }

              this.saveInProgress = false;
              this.dialogRef.disableClose = false;
            });
          }
        );
      });
    }
  }

  private getDelay(data) {
    switch (data) {
      case 'communicationManager':
      case 'sequences':
        return 30000;
      case 'firmware':
      case 'firmwaretest':
      case 'fountain':
        return 120000;
    }

    return 60000;
  }

  handleFile(event) {
    const reader = new FileReader();

    this.isUploadingFile = true;
    this.dialogRef.disableClose = true;

    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        const url = `/parks/${this.controllerId}/updates`;
        const body = {
          update_file: {
            file_name: file.name,
            file_type: file.type,
            content: reader.result.split(',')[1]
          }
        };

        this.http.post(url, body).subscribe(
          (res: { url: string }) => {
            this.isUploadingFile = false;
            this.dialogRef.disableClose = false;

            if (res.hasOwnProperty('url')) {
              this.updateControllerForm.patchValue({
                url: res.url
              });
            }
          }, (err) => {
            this.isUploadingFile = false;
            this.dialogRef.disableClose = false;
            // console.log(err);
          }, () => {
            this.isUploadingFile = false;
            this.dialogRef.disableClose = false;
          });
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/controller/update.controller.dialog.component.ts